import axios from 'axios'
import endpoints from '@/api/endpoints'

export default {
  async getIrrigationDashboard () {
    return axios.get(endpoints.irrigationDashboard).then((response) => {
      return response.data
    })
  },
  async getIrrigationProjects () {
    return axios.get(endpoints.projects + '?division__division_type=I').then((response) => {
      return response.data
    })
  },
  async irrigationSelectList () {
    // Returns a very slim list of projects
    return axios.get(endpoints.projects + 'irrigation_list/').then((response) => {
      return response.data
    })
  },
  async updateIrrigationProject (irrigation) {
    return axios.patch(endpoints.irrigations + irrigation.id + '/', irrigation).then((response) => {
      return response.data;
    }).catch(err => {
      console.log(err.response.data);
    })
  },
  async irrigationSearch (search, exact) {
    return axios.get(endpoints.irrigationSearch + `?name=${search}&number=${search}&site_address=${search}&exact=${exact}&`).then((response) => {
      return response.data
    })
  },
  async getSUBDTiers () {
    return axios.get(endpoints.SUBDTiers).then((response) => {
      return response.data
    })
  },
  async createOneTimeNote (payload) {
    return axios.post(endpoints.oneTimeNotes, payload).then((response) => {
      return response.data
    })
  },
  async getOneTimeNotes (projectId) {
    return axios.get(endpoints.oneTimeNotes + '?project=' + projectId).then((response) => {
      return response.data
    })
  },
  async updateOneTimeNote (payload) {
    return axios.patch(endpoints.oneTimeNotes + payload.id + '/', payload).then((response) => {
      return response.data
    })
  },
  async deleteOneTimeNote (id) {
    return axios.delete(endpoints.oneTimeNotes + id + '/').then((response) => {
      return response.data
    })
  },
  async getControllers () {
    return axios.get(endpoints.inventory + '?is_controller=True').then((response) => {
      return response.data
    })
  },

  // SUBD Tiers
  async getSubdTiers () {
    return axios.get(endpoints.SUBDTiers + '?is_custom=false').then((response) => {
      return response.data
    })
  },
  // async getSubdTier (objID) {
  //   return axios.get(endpoints.SUBDTiers + objID + '/').then((response) => {
  //     return response.data
  //   })
  // },
  async newSubdTier (obj) {
    return axios.post(endpoints.SUBDTiers, obj).then((response) => {
      return response.data
    })
  },
  async updateSubdTier (obj) {
    return axios.patch(endpoints.SUBDTiers + obj.id + '/', obj).then((response) => {
      return response.data
    })
  },
  async deleteSubdTier (obj) {
    return axios.delete(endpoints.SUBDTiers + obj.id + '/').then((response) => {
      return response.data
    })
  },

  async createSUBDTrackers () {
    return axios.post(endpoints.irrigations + 'create_subd_trackers/').then((response) => {
      return response.data
    })
  },
  async updateWONotes (projectId) {
    return axios.get(endpoints.projects + projectId + '/update_wo_notes/').then((response) => {
      return response.data
    })
  },
}
